import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "formulaire" }
const _hoisted_2 = {
  key: 0,
  class: "message error"
}
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { for: "codeAcces" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { for: "codeEmail" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "form-actions" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "spinner"
}
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("h3", null, "Obtenir mes coordonnées / Get my contact details", -1)),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, [
          _cache[3] || (_cache[3] = _createTextVNode("Code d'accès / Access code ", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "codeAcces",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.codeAcces) = $event)),
            disabled: _ctx.loading,
            required: ""
          }, null, 8, _hoisted_5), [
            [_vModelText, _ctx.codeAcces]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", _hoisted_7, [
          _cache[4] || (_cache[4] = _createTextVNode("Code e-mail / Email code ", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "codeEmail",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.codeEmail) = $event)),
            disabled: _ctx.loading,
            required: ""
          }, null, 8, _hoisted_8), [
            [_vModelText, _ctx.codeEmail]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          type: "submit",
          disabled: _ctx.loading
        }, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11))
            : (_openBlock(), _createElementBlock("span", _hoisted_12, "Valider / Commit"))
        ], 8, _hoisted_10)
      ])
    ], 32)
  ]))
}